import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCircleSlash = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C14.3534 2.5 16.5069 3.35573 18.1663 4.77299L4.77299 18.1663C3.35573 16.5069 2.5 14.3534 2.5 12ZM5.83365 19.227C7.49312 20.6443 9.64663 21.5 12 21.5C17.2467 21.5 21.5 17.2467 21.5 12C21.5 9.64663 20.6443 7.49312 19.227 5.83365L5.83365 19.227Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgCircleSlash;
